export const normalizePhoneNumber = (rawPhone) => {
  if (!rawPhone) return "";

  let phone = rawPhone.replace(/\D/g, "");

  // Already contains international format (heuristic)
  if (phone.startsWith("1") && phone.length === 11) return phone; // US/CA
  if (phone.startsWith("44")) return phone; // UK
  if (phone.startsWith("60")) return phone; // MY
  if (phone.startsWith("65")) return phone; // SG
  if (phone.startsWith("61")) return phone; // AU
  if (phone.startsWith("86")) return phone; // CN

  // ----------------------------
  // Country inference (local formats)
  // ----------------------------

  // 🇲🇾 Malaysia
  if (phone.startsWith("0")) {
    if (phone.length >= 9 && phone.length <= 10) {
      return "60" + phone.substring(1);
    }
  }

  // 🇸🇬 Singapore (8 digits, starts with 8 or 9)
  if (phone.length === 8 && /^[89]/.test(phone)) {
    return "65" + phone;
  }

  // 🇨🇳 China (mobile numbers start with 1 and are 11 digits)
  if (phone.length === 11 && phone.startsWith("1")) {
    return "86" + phone;
  }

  // 🇦🇺 Australia (mobile usually 9 digits starting with 4)
  if (phone.length === 9 && phone.startsWith("4")) {
    return "61" + phone;
  }

  // 🇬🇧 UK (mobile usually 10 digits starting with 7, local 0 prefix)
  if (phone.length === 11 && phone.startsWith("0")) {
    return "44" + phone.substring(1);
  }

  // 🇺🇸 US (10 digits, no leading 0)
  if (phone.length === 10) {
    return "1" + phone;
  }

  // Fallback (default to Malaysia if unknown)
  if (phone.startsWith("0")) {
    return "60" + phone.substring(1);
  }

  return phone;
};